"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMatchValue = void 0;

var react_1 = __importDefault(require("react"));

var Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));

var Tab_1 = __importDefault(require("@material-ui/core/Tab"));

var react_router_dom_1 = require("react-router-dom");

exports.getMatchValue = function (value, pathname, exact) {
  if (exact === true) {
    return value;
  }

  var re = new RegExp("^".concat(value, ".*"), 'g');
  var match = pathname.match(re);
  return match === null ? value : pathname;
};

exports.default = function (props) {
  var tabs = props.tabs,
      prefix = props.prefix,
      _props$exact = props.exact,
      exact = _props$exact === void 0 ? true : _props$exact;
  return react_1.default.createElement(react_router_dom_1.Route, {
    path: '/',
    render: function render(_ref) {
      var location = _ref.location;
      var pathname = location.pathname;
      return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Tabs_1.default, {
        value: pathname
      }, tabs.map(function (t, i) {
        var value = prefix + t.link;
        var matchValue = exports.getMatchValue(value, pathname, exact);
        return react_1.default.createElement(Tab_1.default, {
          key: i,
          label: t.label,
          value: matchValue,
          to: value,
          component: react_router_dom_1.Link
        });
      })), react_1.default.createElement(react_router_dom_1.Switch, null, tabs.map(function (t, i) {
        return react_1.default.createElement(react_router_dom_1.Route, {
          key: i,
          exact: exact,
          path: prefix + t.link,
          render: function render() {
            return t.Component;
          }
        });
      })));
    }
  });
};